import findIndex from 'lodash/findIndex';
import get from 'lodash/get';

import * as integrationConfig from 'actions/integrationConfig';
import { UPDATE_WORKFLOW_SUCCESS } from 'actions/workflows';

const defaultState = {
  data: null,
  status: 'NOT_LOADED',
};

function onDeleteSuccess(state, action) {
  const data = state.data.filter(config => config.id !== action.payload.id);
  return {
    ...state,
    data,
  };
}

function safelyAddDataById(state, action) {
  if (state.data) {
    const index = findIndex(state.data, e => e.id === action.payload.id);
    if (index < 0) {
      return {
        ...state,
        data: [...state.data, action.payload],
      };
    }

    const updatedPlan = {
      ...state.data[index],
      ...action.payload,
    };

    return {
      ...state,
      data: [
        ...state.data.slice(0, index),
        updatedPlan,
        ...state.data.slice(index + 1),
      ],
    };
  }
  return state;
}

function onLoadOneConfigSuccess(state, action) {
  if (action.payload.id) {
    const newState = safelyAddDataById(state, action);

    const singleConfig = get(state, 'oneConfig.data', {});
    const data =
      singleConfig.id === action.payload.id
        ? { ...singleConfig, ...action.payload }
        : action.payload;

    newState.oneConfig = {
      data,
      status: 'LOADED',
    };
    return newState;
  }
  return state;
}

export default function integrationConfigs(state = defaultState, action) {
  switch (action.type) {
    case integrationConfig.LOAD_START:
      return {
        ...state,
        data: state.data,
        status: 'LOADING',
      };
    case integrationConfig.LOAD_SINGLE_START:
      return {
        ...state,
        data: state.data || [],
        oneConfig: {
          data: {},
          status: action.payload.isPolling ? state.status : 'LOADING',
        },
      };
    case UPDATE_WORKFLOW_SUCCESS:
      if (action.payload.id === get(state, 'oneConfig.data.id', '')) {
        return onLoadOneConfigSuccess(state, action);
      }

      return state;
    case integrationConfig.LOAD_AVAILABLE_XAGENTS_START:
      return {
        ...state,
        xAgents: {
          data: get(state, 'xAgents.data', []),
          status: 'LOADING',
        },
      };
    case integrationConfig.LOAD_SUCCESS:
      return {
        ...state,
        ...action.payload,
        status: 'LOADED',
      };
    case integrationConfig.LOAD_SINGLE_SUCCESS:
      return onLoadOneConfigSuccess(state, action);
    case integrationConfig.LOAD_AVAILABLE_XAGENTS_SUCCESS:
      return {
        ...state,
        xAgents: {
          data: action.payload.data,
          status: 'LOADED',
        },
      };
    case integrationConfig.LOAD_FAIL:
      return {
        ...state,
        data: null,
        status: 'FAILED',
      };
    case integrationConfig.LOAD_SINGLE_FAIL:
      return {
        ...state,
        oneConfig: {
          data: null,
          status: 'FAILED',
        },
      };
    case integrationConfig.LOAD_AVAILABLE_XAGENTS_FAIL:
      return {
        ...state,
        xAgents: {
          data: null,
          status: 'FAILED',
        },
      };
    case integrationConfig.DELETE_SUCCESS: {
      return onDeleteSuccess(state, action);
    }
    case integrationConfig.SAVE_SUCCESS:
      return onLoadOneConfigSuccess(state, action);

    // These integrationConfig.* do not alter the state. The resulting values (if any) are handled in the code.
    case integrationConfig.GENERATE_AUTH_CODE_START:
    case integrationConfig.GENERATE_AUTH_CODE_SUCCESS:
    case integrationConfig.GENERATE_AUTH_CODE_FAIL:
    case integrationConfig.SAVE_XM_CONFIG_START:
    case integrationConfig.SAVE_XM_CONFIG_SUCCESS:
    case integrationConfig.SAVE_XM_CONFIG_FAIL:
    default:
      return state;
  }
}
